module.exports = __webpack_public_path__ + "img/banner2-En1.202bb9f7.jpg";